const areas = [
  {
    name: 'Chelmsford',
    description: 'As the county town of Essex, we provide comprehensive bollard installation services throughout Chelmsford and surrounding areas.',
    population: '180,000+',
    icon: 'ri-building-line',
    slug: 'chelmsford'
  },
  {
    name: 'Colchester',
    description: 'Britain\'s oldest recorded town receives our full range of residential and commercial bollard solutions.',
    population: '195,000+',
    icon: 'ri-ancient-gate-line',
    slug: 'colchester'
  },
  {
    name: 'Basildon',
    description: 'Serving Basildon with professional bollard installation for driveways, car parks, and commercial properties.',
    population: '185,000+',
    icon: 'ri-community-line',
    slug: 'basildon'
  },
  {
    name: 'Southend-on-Sea',
    description: 'Coastal properties and businesses in Southend benefit from our durable bollard installation services.',
    population: '295,000+',
    icon: 'ri-ship-line',
    slug: 'southend-on-sea'
  },
  {
    name: 'Harlow',
    description: 'Complete bollard installation coverage across Harlow, including residential estates and business parks.',
    population: '88,000+',
    icon: 'ri-home-gear-line',
    slug: 'harlow'
  },
  {
    name: 'Braintree',
    description: 'Professional bollard solutions for properties throughout Braintree and the surrounding district.',
    population: '150,000+',
    icon: 'ri-landscape-line',
    slug: 'braintree'
  },
  {
    name: 'Brentwood',
    description: 'High-quality bollard installation services for Brentwood\'s residential and commercial properties.',
    population: '77,000+',
    icon: 'ri-home-smile-line',
    slug: 'brentwood'
  },
  {
    name: 'Grays',
    description: 'Serving Grays and Thurrock with reliable bollard installation for enhanced property security.',
    population: '175,000+',
    icon: 'ri-building-2-line',
    slug: 'grays'
  },
  {
    name: 'Clacton-on-Sea',
    description: 'Coastal bollard solutions for Clacton properties, designed to withstand maritime conditions.',
    population: '54,000+',
    icon: 'ri-sun-line',
    slug: 'clacton-on-sea'
  },
  {
    name: 'Rayleigh',
    description: 'Expert bollard installation throughout Rayleigh, protecting driveways and commercial premises.',
    population: '32,000+',
    icon: 'ri-shield-check-line',
    slug: 'rayleigh'
  },
  {
    name: 'Wickford',
    description: 'Comprehensive bollard services for Wickford residents and businesses seeking enhanced security.',
    population: '33,000+',
    icon: 'ri-lock-line',
    slug: 'wickford'
  },
  {
    name: 'Billericay',
    description: 'Premium bollard installation solutions for Billericay\'s residential and commercial properties.',
    population: '42,000+',
    icon: 'ri-home-heart-line',
    slug: 'billericay'
  },
  {
    name: 'Witham',
    description: 'Professional bollard installation services across Witham and the surrounding villages.',
    population: '25,000+',
    icon: 'ri-road-map-line',
    slug: 'witham'
  },
  {
    name: 'Loughton',
    description: 'Serving Loughton with expert bollard installation for residential driveways and business premises.',
    population: '31,000+',
    icon: 'ri-parking-box-line',
    slug: 'loughton'
  },
  {
    name: 'Maldon',
    description: 'Historic Maldon receives modern bollard solutions for property protection and access control.',
    population: '64,000+',
    icon: 'ri-castle-line',
    slug: 'maldon'
  },
  {
    name: 'Saffron Walden',
    description: 'Quality bollard installation throughout Saffron Walden and the Uttlesford district.',
    population: '90,000+',
    icon: 'ri-flower-line',
    slug: 'saffron-walden'
  },
  {
    name: 'Canvey Island',
    description: 'Island properties benefit from our specialized bollard installation and maintenance services.',
    population: '38,000+',
    icon: 'ri-water-flash-line',
    slug: 'canvey-island'
  },
  {
    name: 'Epping',
    description: 'Comprehensive bollard solutions for Epping Forest district properties and businesses.',
    population: '132,000+',
    icon: 'ri-tree-line',
    slug: 'epping'
  },
  {
    name: 'Rochford',
    description: 'Expert bollard installation services throughout Rochford district for enhanced security.',
    population: '87,000+',
    icon: 'ri-shield-star-line',
    slug: 'rochford'
  },
  {
    name: 'Stansted',
    description: 'Serving Stansted and surrounding areas with professional bollard installation solutions.',
    population: '6,000+',
    icon: 'ri-plane-line',
    slug: 'stansted'
  },
  {
    name: 'Tilbury',
    description: 'Industrial and residential bollard installation services throughout Tilbury and the port area.',
    population: '12,000+',
    icon: 'ri-ship-2-line',
    slug: 'tilbury'
  },
  {
    name: 'Waltham Abbey',
    description: 'Quality bollard solutions for Waltham Abbey properties, combining security with aesthetics.',
    population: '21,000+',
    icon: 'ri-church-line',
    slug: 'waltham-abbey'
  },
  {
    name: 'Leigh-on-Sea',
    description: 'Coastal bollard installation expertise for Leigh-on-Sea residential and commercial properties.',
    population: '22,000+',
    icon: 'ri-sailboat-line',
    slug: 'leigh-on-sea'
  },
  {
    name: 'Chigwell',
    description: 'Premium bollard installation services for Chigwell\'s high-value residential properties.',
    population: '13,000+',
    icon: 'ri-vip-crown-line',
    slug: 'chigwell'
  }
];

export default function AreasGridSection() {
  return (
    <section id="areas" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black mb-4">
            Complete <span className="text-yellow-500">Essex Coverage</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We proudly serve all major towns and cities across Essex with professional bollard installation services. 
            No matter where you are in the county, we're ready to help secure your property.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {areas.map((area, index) => (
            <a 
              key={index}
              href={`/areas/${area.slug}`}
              className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-xl hover:border-yellow-500/50 transition-all duration-300 cursor-pointer group block"
            >
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-yellow-500/10 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-yellow-500 transition-colors">
                  <i className={`${area.icon} text-yellow-500 text-2xl group-hover:text-black transition-colors`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold mb-2 group-hover:text-yellow-500 transition-colors">
                    {area.name}
                  </h3>
                  <p className="text-gray-600 text-sm mb-3 leading-relaxed">
                    {area.description}
                  </p>
                  <div className="flex items-center space-x-2 text-sm text-gray-500">
                    <i className="ri-group-line text-yellow-500"></i>
                    <span>{area.population} residents</span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="bg-gradient-to-br from-black to-gray-900 rounded-2xl p-12 text-center text-white">
          <div className="max-w-3xl mx-auto">
            <h3 className="text-3xl md:text-4xl font-black mb-4">
              Don't See Your Area Listed?
            </h3>
            <p className="text-xl text-gray-300 mb-8">
              We cover the entire Essex county! If your location isn't listed above, don't worry - 
              we still provide our professional bollard installation services in your area. 
              Contact us today for a free consultation and quote.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a href="tel:+447834858178" className="bg-yellow-500 text-black px-8 py-3 rounded-lg font-semibold hover:bg-yellow-400 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center space-x-2">
                <i className="ri-phone-line"></i>
                <span>Call +44 7834 858178</span>
              </a>
              <a href="/quote" className="bg-white/10 backdrop-blur-sm text-white border border-white/20 px-8 py-3 rounded-lg font-semibold hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center space-x-2">
                <i className="ri-file-list-line"></i>
                <span>Request Quote</span>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-yellow-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-line text-yellow-500 text-3xl"></i>
            </div>
            <h4 className="text-xl font-bold mb-2">Fast Response</h4>
            <p className="text-gray-600">
              Quick response times across all Essex locations with same-day quotes available
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-yellow-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-yellow-500 text-3xl"></i>
            </div>
            <h4 className="text-xl font-bold mb-2">Local Expertise</h4>
            <p className="text-gray-600">
              Deep knowledge of Essex properties and local regulations for compliant installations
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-yellow-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-customer-service-line text-yellow-500 text-3xl"></i>
            </div>
            <h4 className="text-xl font-bold mb-2">Dedicated Support</h4>
            <p className="text-gray-600">
              Ongoing maintenance and support services available throughout Essex
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
